/*
 * <category-pills-scroller> — progressive scroll affordance for the category pill row.
 * Toggles edge-fade classes when the row can scroll further left/right, and removes
 * them at the ends. On connect, the row is scrolled so the active pill sits centered.
 * Without JS the row still scrolls; the fades simply never appear.
 */
if (!customElements.get('category-pills-scroller')) {
  customElements.define(
    'category-pills-scroller',
    class CategoryPillsScroller extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('.collection-pills');
        if (!this.scroller) return;

        this.update = this.update.bind(this);
        this.scroller.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update, { passive: true });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(this.scroller);
        }

        this.centerActivePill();
        this.update();
      }

      centerActivePill() {
        const active = this.scroller.querySelector('.collection-pill--active');
        if (!active) return;

        const item = active.closest('.collection-pills__item') || active;
        const el = this.scroller;
        const delta = item.getBoundingClientRect().left - el.getBoundingClientRect().left;
        // The browser clamps the value to the scrollable range, so a row that
        // fits entirely (desktop) or an active pill near an edge needs no guard.
        el.scrollLeft += delta - (el.clientWidth - item.offsetWidth) / 2;
      }

      disconnectedCallback() {
        if (this.scroller) this.scroller.removeEventListener('scroll', this.update);
        window.removeEventListener('resize', this.update);
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      update() {
        const el = this.scroller;
        const maxScroll = el.scrollWidth - el.clientWidth;
        const x = el.scrollLeft;
        const threshold = 1; // ignore sub-pixel rounding

        this.classList.toggle('has-more-left', x > threshold);
        this.classList.toggle('has-more-right', x < maxScroll - threshold);
      }
    }
  );
}
